import { createApp } from 'vue';
import sf from "./modules/smartyfaces";
import moment from "moment";
import Calendar from "./components/Calendar.vue";
import video from "../../util/iframely/plugins/meta/video";
import tooltipDirective from "./modules/tooltip";

window.videoApp = createApp({
    delimiters: ['[[', ']]'],
    components: {Calendar},
    data() {
        return {
            sports: [],
            sportsOn: null,
            selDate: null,
            videos: [],
            direction: 'asc',
            videoDay: null,
            videoSelKey: null,
            selVideo: null,
            calendarVideos: {}
        }
    },
    computed: {
        selDateFormatted() {
            return this.selDate && moment(this.selDate).format('DD.MM.YYYY')
        },
        selMonth() {
            return this.selDate && moment(this.selDate).month()+1
        },
        selYear() {
            return this.selDate && moment(this.selDate).year()
        }
    },
    mounted() {
        this.selDate = moment().subtract('hour', 2).format('YYYY-MM-DD')
        this.videoSelKey = moment().subtract('hour', 2).format('YYYY-MM-DD-HH:mm')
        this.init()
        if(localStorage.getItem('sportsOn')){
            this.sportsOn = JSON.parse(localStorage.getItem('sportsOn'))
        }
    },
    beforeUpdate(e) {
        console.log('beforeUpdate',e)
    },
    methods: {
        init() {
            sf.ajax('VideoBrowseView::init').then(response => {
                this.sports = response.data.result.sports
                if(this.sportsOn === null) {
                    this.sportsOn = []
                    this.sports.map(item => {
                        this.sportsOn.push(item.sport_id)
                    })
                    localStorage.setItem("sportsOn", JSON.stringify(this.sportsOn))
                }
                this.showLoadingVideos(this.getVideos)
            })
        },
        toggleSport(sport_id) {
            if(this.sportsOn.includes(sport_id)) {
                this.sportsOn.splice(this.sportsOn.indexOf(sport_id), 1)
            } else {
                this.sportsOn.push(sport_id)
            }
            localStorage.setItem("sportsOn", JSON.stringify(this.sportsOn))
            this.showLoadingVideos(this.getVideos)
        },
        isSportOn(sport) {
            return this.sportsOn.includes(sport.sport_id)
        },
        prevGames() {
            if(this.videos[0]) {
                this.videoSelKey = this.videos[0].item_key
            }
            this.direction = 'desc'
            this.showLoadingVideos(this.getVideos, ()=>{
                if(this.videos[0] && this.videos[0].game_date) {
                    this.selDate = this.videos[0].game_date
                }
            })
        },
        showLoadingVideos(fn, cb = null) {
            window.showLoadingStatus('video-list');
            fn(()=>{
                $("#video-list").fadeTo(50,1);
                $("div#loading").hide();
                if(cb) cb()
            });
        },
        nextGames() {
            if(this.videos[this.videos.length - 1]) {
                this.videoSelKey = this.videos[this.videos.length - 1].item_key;
            }
            this.direction = 'asc'
            this.showLoadingVideos(this.getVideos, ()=>{
                if(this.videos[0] && this.videos[0].game_date) {
                    this.selDate = this.videos[0].game_date
                }
            })
        },
        getVideos(cb = null) {
            sf.ajax('VideoBrowseView::getVideos', {
                key: this.videoSelKey,
                direction: this.direction,
                sports: this.sportsOn
            }).then(response => {
                this.videos = response.data.result;
                if(!this.selVideo) {
                    this.selVideo = this.videos[0];
                }
                if(cb) cb()
            });
        },
        playVideo(video) {
            this.selVideo = video
            this.$nextTick(()=>{
                let iframe = $('.video-player iframe')
                let src = iframe.attr('src')
                if (!src.includes("autoplay=1")) {
                    if (src.includes("?")) {
                        src += "&autoplay=1&mute=0";
                    } else {
                        src += "?autoplay=1&mute=0";
                    }
                    iframe.attr("src", src);
                }
            })
        },
        dayClass(d) {
            let date = d.date
            if(date) {
                if(this.calendarVideos[date]) {
                    return 'calendar-day-fill'
                }
            }
        },
        changedMonth(data) {
            sf.ajax('VideoBrowseView::getCalendarVideos',
                data
            ).then(response => {
                this.calendarVideos = response.data.result;
            })
        },
        dayTooltip(day) {
            let date = day.date
            if(date) {
                if (this.calendarVideos[date]) {
                    return this.calendarVideos[date].title
                }
            }
        },
        selectedDay(day) {
            this.selDate = day.date
            this.videoSelKey = this.selDate;
            this.showLoadingVideos(this.getVideos)
        }
    }
})
window.videoApp.directive('tooltip', tooltipDirective);
window.videoApp.mount("#video-app");